import { useState } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
// import logo from "../../src/Assets/logo.png";
import logo from "../../src/Assets/aloklogo.svg";
import logoNameH from "../../src/Assets/logo_AF_H.png";
import "./navbar.css";
import { NavLink } from "react-router-dom";

const CustomNavbar = () => {
  const [expanded, setExpanded] = useState(false);

  const handleNavClick = () => {
    setExpanded(false);
  };
  return (
    <Navbar expand="lg" className="sticky-top bg-white shadow" expanded={expanded}>
      <Container>
        <Navbar.Brand href="/" className="d-flex align-items-center m-0">
          <img
            src={logo}
            alt="Alok Fabrications Logo"
            width="60"
            height="40"
            className="d-inline-block align-top"
          />
          <img
            src={logoNameH}
            alt="Alok Fabrications Logo"
            height="30"
            className="d-inline-block align-top alok_logo_name"
          />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setExpanded(expanded ? false : true)}
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <NavLink to="/" className="nav-link" onClick={handleNavClick}>
              Home
            </NavLink>
            <NavLink to="/about" className="nav-link" onClick={handleNavClick}>
              About Us
            </NavLink>
            <NavLink to="/products" className="nav-link" onClick={handleNavClick}>
              Products
            </NavLink>
            <NavLink to="/contact" className="contactusbtn" onClick={handleNavClick}>
              Contact Us
            </NavLink>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
